import Image from "next/image";
import Link from "next/link";
import { Headline } from "~/ui-library";
import { Card } from "~/ui-library/components/Card/Card";
import { buttonStyles } from "~/ui-library/shared-styles/shared-button-styles";

export const SubCheckoutCompletion: React.FC = () => (
  <Card
    className="flex flex-col items-center justify-center gap-m p-l md:px-xl md:py-l"
    elevation={0}
  >
    <Image
      src={"/assets/PRO-small.png"}
      width={"250"}
      height={"250"}
      className="size-fit self-center"
      alt="MCPro Logo"
    ></Image>
    <div className="w-m"></div>
    <Headline level={3}>You&apos;re in.</Headline>
    <div className="max-w-lg text-center">
      Your unlimited access to all of Morning Consult Pro’s analysis, charts and
      data starts today.
    </div>
    <Link
      className={buttonStyles({
        variant: "primary",
        size: "default",
        className: "flex items-center justify-center font-semibold",
      })}
      href="/"
    >
      Homepage
    </Link>
  </Card>
);
